<template>
  <div 
    ref="scrollContainer"
    :class="[
      'w-screen h-screen overflow-auto',
      isAdmin 
        ? 'bg-gradient-to-b from-slate-50 from-60% to-amber-100 to-90%' 
        : 'bg-gradient-to-b from-slate-50 from-60% to-slate-100 to-90%'
    ]"
    @scroll="handleScroll"
    >
      <div class="container mx-auto wrapper max-w-5xl">
          <slot></slot>
      </div>
  </div>
  </template>

<script>
export default {
  emits: ['scrolled'],
  computed: {
    isAdmin() {
      return this.$store.state.Role === 'admin';
    }
  },
  data() {
    return {
      scrollContainer: null
    };
  },
  mounted() {
    this.scrollContainer = this.$refs.scrollContainer;
  },
  methods: {
    handleScroll() {
      const scrollTop = this.scrollContainer.scrollTop;
      this.$emit('scrolled', scrollTop > 50);
    }
  }
};
</script>